import React from "react";

import { Button } from "@/components/ui/button";
import useGlobalPermission from "@/store/user-permissions";
type KnowledgeSourceButtonsProps = {
    onSubmit?: () => void;
    loading?: boolean;
    disabled?: boolean;
};

const KnowledgeSourceButtons: React.FC<KnowledgeSourceButtonsProps> = ({ onSubmit, loading = false, disabled = false }) => {
    const { permissionList } = useGlobalPermission();
    const trainingPermission = permissionList.find((item) => item.module.name === "AI_Training");
    return (
        <div className="flex h-10 justify-end gap-4">
            <Button className="h-full w-44 cursor-pointer" onClick={onSubmit} disabled={loading || disabled || !trainingPermission?.can_create}>
                Add Source
            </Button>
        </div>
    );
};

export default KnowledgeSourceButtons;
